import stores from 'cd-eft/models/Stores';
import { IUgoPipeSpecification } from 'cd-eft/models/Stores/UGODesignStore';

const { ugoDesignStore } = stores.AppStore;

interface IFixtureModalInputs {
  readonly label?: string;
  readonly inputType: 'text' | 'number' | 'dropdown' | 'radio' | 'title' | 'checkbox' | 'switch';
  name: string;
  options?: any;
  readOnly?: boolean;
  disabled?: boolean;
}

export const FixtureModalConfig: Record<string, Record<string, IFixtureModalInputs>> = {
  FixtureMainSection: {
    fixtureType: {
      label: 'Fixture Type',
      inputType: 'dropdown',
      name: 'fixtureType',
      options: ugoDesignStore.fixtureTypeOptions,
    },
    name: {
      label: 'Name',
      inputType: 'text',
      name: 'name',
    },
    station: {
      label: 'Station (ft)',
      inputType: 'number',
      name: 'station',
      readOnly: true,
    },
    pipeElevation: {
      label: 'Pipe Elevation (ft)',
      inputType: 'number',
      name: 'pipeElevation',
      readOnly: true,
    },
    flowQ: {
      label: 'Flow Q (cfs)',
      inputType: 'number',
      name: 'flowQ',
      readOnly: true,
    },
    material: {
      label: 'Material',
      inputType: 'dropdown',
      name: 'material',
      options: ugoDesignStore.pipelineMaterialOptions,
    },
    pipeSize: {
      label: 'Pipe Size (in)',
      inputType: 'number',
      name: 'pipeSize',
    },
    pressurizableMain: {
      label: 'Pressurizable',
      inputType: 'checkbox',
      name: 'pressurizableMain',
      disabled: true,
    },
    manningN: {
      label: 'Manning\'s N',
      inputType: 'number',
      name: 'manningN',
      readOnly: true,
    }
  },
  StandardOutletSection: {
    useAnimalGuard: { label: 'Use Animal Guard', inputType: 'checkbox', name: 'useAnimalGuard' },
    length: { label: 'Length (ft)', inputType: 'number', name: 'length' },
    head: { label: 'Head (ft)', inputType: 'number', name: 'head' },
  },
  VerticalOutletSection: {
    rimElevation: { label: 'Rim Elevation (ft)', inputType: 'number', name: 'rimElevation' },
    pipeLength: { label: 'Vertical Pipe Length (ft)', inputType: 'number', name: 'pipeLength', readOnly: true },
    useAnimalGuard: { label: 'Use Animal Guard', inputType: 'checkbox', name: 'useAnimalGuard' },
    useRockFill: { label: 'Use Rock Fill', inputType: 'checkbox', name: 'useRockFill' },
    rockQuantity: { label: 'Rock Quantity (tons)', inputType: 'number', name: 'rockQuantity' },
    useDrainPipe: { label: 'Use Drain Pipe', inputType: 'switch', name: 'useDrainPipe' },
    useAnimalGuardDrain: { label: 'Use Animal Guard', inputType: 'switch', name: 'useAnimalGuardDrain' },
    material: { label: 'Material', inputType: 'dropdown', name: 'material', options: ugoDesignStore.pipelineMaterialOptions },
    perforated: { label: 'Perforated', inputType: 'checkbox', name: 'perforated' },
    pressurizable: { label: 'Pressurizable', inputType: 'checkbox', name: 'pressurizable', disabled: true },
    pipeSize: { label: 'Pipe Size (in)', inputType: 'number', name: 'pipeSize' },
    manningsN: { label: "Manning's N", inputType: 'number', name: 'manningsN', readOnly: true },
    outletOptions: { label: 'Outlet Options', inputType: 'title', name: 'outletOptions' },
    drainPipeOptions: { label: 'Drain Pipe Options', inputType: 'title', name: 'drainPipeOptions' },
  },
  JunctionSection: {
    junctionFlowConnection: {
      label: 'Junction Flow Connection',
      inputType: 'title',
      name: 'junctionFlowConnection',
    },
    addedQ: {
      label: 'Added Q (cfs)',
      inputType: 'number',
      name: 'addedQ',
    },
    addedQSource: {
      label: 'Added Q Source',
      inputType: 'text',
      name: 'addedQSource',
    },
    pipelineJunction: {
      label: 'Pipeline and Junction',
      inputType: 'dropdown',
      name: 'pipelineJunction',
      options: [
        {
          name: 'No Connection',
          value: 'No Connection'
        }
      ],
    },
  },
  CanopyInletSection: {
    useTrashGuard: {
      label: 'Use Trash Guard',
      inputType: 'checkbox',
      name: 'useTrashGuard'
    },
    pressureFlow: {
      label: 'Pressure Flow',
      inputType: 'checkbox',
      name: 'pressureFlow',
    }
  },
  RiserInletSection: {
    guard: {
      label: 'Guard',
      inputType: 'dropdown',
      name: 'guard',
      options: [
        { name: 'Trash Guard', value: 'Trash Guard', key: 1 },
        { name: 'No Guard', value: 'No Guard', key: 2 },
        { name: 'Capped', value: 'CAPPED', key: 3 }
      ],
    },
    topOpeningDiameter: {
      label: 'Top Opening (in)',
      inputType: 'number',
      name: 'topOpeningDiameter',
    },
    pluggedFraction: {
      label: 'Plugged Fraction',
      inputType: 'number',
      name: 'pluggedFraction',
    },
    qtop: {
      label: 'Qtop (cfs)',
      inputType: 'number',
      name: 'qtop',
      readOnly: true,
    }
  },
  PerforatedRiserSection: {
    holesPerFt: {
      label: 'Holes per (ft)',
      inputType: 'number',
      name: 'holesPerFt',
    },
    height: {
      label: 'Height (ft)',
      inputType: 'number',
      name: 'height',
    },
    pluggedPerfFraction: {
      label: 'Plugged Perf Fraction',
      inputType: 'number',
      name: 'pluggedPerfFraction',
    },
    perfShape: {
      label: 'Perforation Type',
      inputType: 'radio',
      name: 'perfShape',
    },
    perfDiameter: {
      label: 'Perf. diam (in)',
      inputType: 'number',
      name: 'perfDiameter',
    },
    perfWidth: {
      label: 'Perf Width (in)',
      inputType: 'number',
      name: 'perfWidth',
    },
    perfHeight: {
      label: 'Height (in)',
      inputType: 'number',
      name: 'perfHeight',
    },
    qperf: {
      label: 'Qperf (cfs)',
      inputType: 'number',
      name: 'qperf',
      readOnly: true,
    }
  },
  WaterSourceSection: {
    terraceAndOutlet: {
      label: 'Terrace and Outlet',
      inputType: 'dropdown',
      name: 'terraceAndOutlet',
      options: [],
    },
    avgFloodDepthFactor: {
      label: 'Average Flood Depth Factor',
      inputType: 'number',
      name: 'avgFloodDepthFactor',
    },
    ugoSizingFloodDepthFactor: {
      label: 'UGO Sizing Flood Depth Factor',
      inputType: 'number',
      name: 'ugoSizingFloodDepthFactor',
    }
  },
  OrificeOffsetSection: {
    useOrifice: {
      label: 'Use Orifice',
      inputType: 'checkbox',
      name: 'useOrifice',
    },
    orificeDepth: {
      label: 'Orifice Depth (in)',
      inputType: 'number',
      name: 'orificeDepth',
    },
    useDefinedSize: {
      label: 'Use Defined Size',
      inputType: 'checkbox',
      name: 'useDefinedSize',
    },
    diameter: {
      label: 'Diameter (in)',
      inputType: 'number',
      name: 'diameter',
    },
    useOffset: {
      label: 'Use Offset',
      inputType: 'checkbox',
      name: 'useOffset',
    },
    offsetLength: {
      label: 'Offset Length (ft)',
      inputType: 'number',
      name: 'offsetLength',
    },
    elbowElevation: {
      label: 'Elbow Elevation (ft)',
      inputType: 'number',
      name: 'elbowElevation',
    },
    offsetMaterial: {
      label: 'Material',
      inputType: 'dropdown',
      name: 'offsetMaterial',
      options: ugoDesignStore.pipelineMaterialOptions,
    },
    perforated: {
      label: 'Perforated',
      inputType: 'checkbox',
      name: 'perforated',
    },
    pressurizable: {
      label: 'Pressurizable',
      inputType: 'checkbox',
      name: 'pressurizable',
      disabled: true,
    },
    offsetPipeSize: {
      label: 'Pipe Size (in)',
      inputType: 'number',
      name: 'offsetPipeSize',
    },
    offsetManningN: {
      label: 'Manning\'s N',
      inputType: 'number',
      name: 'offsetManningN',
      readOnly: true,
    }
  }
}

export const verticalOutletSectionConfig: any = [
  [FixtureModalConfig.VerticalOutletSection.rimElevation, FixtureModalConfig.VerticalOutletSection.pipeLength],
  [FixtureModalConfig.VerticalOutletSection.outletOptions],
  [
    FixtureModalConfig.VerticalOutletSection.useAnimalGuard,
    FixtureModalConfig.VerticalOutletSection.useRockFill,
    FixtureModalConfig.VerticalOutletSection.rockQuantity,
  ],
  [FixtureModalConfig.VerticalOutletSection.drainPipeOptions],
  [FixtureModalConfig.VerticalOutletSection.useDrainPipe, FixtureModalConfig.VerticalOutletSection.useAnimalGuardDrain],
  [
    FixtureModalConfig.VerticalOutletSection.material,
    FixtureModalConfig.VerticalOutletSection.pipeSize,
    FixtureModalConfig.VerticalOutletSection.pressurizable,
  ],
  [FixtureModalConfig.VerticalOutletSection.manningsN],
];
export interface IInputForms {
  FixtureMainSection: {
    fixtureType: number;
    name: string;
    station: number;
    pipeElevation: number;
    flowQ: number;
    material: number | undefined;
    pipeSize: number;
    manningN: number;
    pressurizableMain: boolean;
  };
  StandardOutletSection: {
    useAnimalGuard: boolean;
    length: number;
    head: number;
  };
  JunctionSection: {
    junctionFlowConnection: string;
    override: boolean;
    addedQ: number;
    addedQSource: string;
    pipelineJunction: string;
  };
  VerticalOutletSection: {
    rimElevation: number;
    pipeLength: number;
    useAnimalGuard: boolean;
    useRockFill: boolean;
    rockQuantity: number;
    useDrainPipe: boolean;
    useAnimalGuardDrain: boolean;
    material: number | undefined;
    perforated: boolean | undefined;
    pressurizable: boolean | undefined;
    pipeSize: number;
    manningsN: number;
  };
  CanopyInletSection: {
    useTrashGuard: boolean;
    pressureFlow: boolean;
    terraceRequiredQ: number;
    terraceFloodElev: number;
    channelElev: number;
    terraceAndOutlet: string;
  };
  RiserInletSection: {
    fixtureType: string;
    name: string;
    station: number;
    pipeElevation: number;
    useManufactureRiser: boolean;
    material: string | undefined;
    pipeSize: number;
    guard: string;
    topOpeningDiameter: number;
    pluggedFraction: number;
    qtop: number;
  };
  PerforatedRiserSection: {
    holesPerFt: number;
    height: number;
    pluggedPerfFraction: number;
    perfShape: string;
    perfDiameter: number;
    perfHeight: number;
    perfWidth: number;
    qperf: number;
  };
  WaterSourceSection: {
    terraceRequiredQ: number;
    terraceFloodElev: number;
    channelElev: number;
    terraceAndOutlet: string;
    avgFloodDepthFactor: number;
    ugoSizingFloodDepthFactor: number;
  };
  OrificeOffsetSection: {
    useOrifice: boolean;
    orificeDepth: number;
    useDefinedSize: boolean;
    diameter: number;
    useOffset: boolean;
    offsetLength: number;
    elbowElevation: number;
    offsetMaterial: number | undefined;
    perforated: boolean;
    pressurizable: boolean;
    offsetPipeSize: number;
    offsetManningN: number;
  };
  ResultsSection: {
    averageFlow: number;
    qperfPlusQtop: number;
    releaseTime: string;
    ugoSizingFlow: number;
    qperfPlusQtopUgo: number;
  };
}

/* Interfaces for FixtureDtoJson */
export interface IWaterSource {
  terraceAndOutlet: string;
  terraceRequiredQ: number;
  terraceFloodElev: number;
  channelElev: number;
  pipeDepthBelowChannel: number;
  avgFloodDepthFactor: number;
  ugoSizingFloodDepthFactor: number;
  drainStationDTO: {
    drainName: string;
    drainFraction: number;
    drainOffset: number;
    ugoAndInlet: string;
    location: {
      id: number;
      pointName: string | null;
      x: number;
      y: number;
      z: number;
      visiable: boolean;
      tinnable: boolean;
      description: string | null;
      cutOrFill: number;
      keyString: string | null;
      objectName: string | null;
    },
    drainId: string | null;
    stationDistance: number;
    terraceAlignedId: number;
  };
}

export interface IPipeFitting {
  pipeFittingId: string;
  stationDist: number;
  pipeElevation: number;
  manningN: number;
  fixtureTypeId: number;
  fixtureName: string;
  ugoPipeSpecificationJson: string;
}

export interface IJunction {
  pipeFitting: IPipeFitting;
  junctionFlowConnection: {
    addedQ: number;
    addedQSource: string;
    overrideAddedQ: boolean;
    pipelineAndJunction: string;
  }
}

export interface ICanopyInlet {
  inletPipeFitting: IPipeFitting;
  useTrashGuard: boolean;
  pressureFlow: boolean;
  waterSource: IWaterSource | null;
}

export interface IRiserInlet {
  inletPipeFittingDto: IPipeFitting;
  useManufactureRiser: boolean;
  manufactureRiserId: number;
  inletTop: {
    guardType: string;
    topOpening: number;
    pluggedFraction: number;
  };
  perforatedRiser: {
    perfShape: string;
    holesPerFoot: number;
    height: number;
    roundPerf: boolean;
    perfDiameter: number;
    perfWidth: number;
    perfHeight: number;
    pluggedPerfFraction: number;
    qperf: number;
  };
  waterSource: IWaterSource | null;
  enableWaterSourceEdit: boolean;
  enableChannelEdit: boolean;
  orificePlate: {
    orificeDepth: number;
    diameter: number;
  } | null;
  useOrifice: boolean;
  userDefinedOrificeSize: boolean;
  useOffset: boolean;
  offsetPipe: IUgoPipeSpecification | null;
  riserInletDesignControl: null;
}

export interface IStandardOutlet {
  outletPipeFitting: IPipeFitting;
  useAnimalGuard: boolean;
  length: number;
  head: number;
}

export interface IVerticalOutlet {
  outletPipeFitting: IPipeFitting;
  remElevation: number;
  useAnimalGuard4Outlet: boolean;
  useRockFill: boolean;
  rockQuantity: number;
  useDrainPipe: boolean;
  drainLength: number;
  drainPipeFitting: IPipeFitting | null;
  useAnimalGuard4Drain: boolean;
}

export type FixtureDto =
  | IPipeFitting
  | IJunction
  | ICanopyInlet
  | IRiserInlet
  | IStandardOutlet
  | IVerticalOutlet;
